// in src/Dashboard.js
import React, { useState } from 'react';

import { useEffect } from 'react';


import Grid from '@mui/material/Grid';
import Box from '@material-ui/core/Box';
import { useCreate, useRefresh, useDataProvider, useNotify } from 'react-admin';import { parse } from 'query-string';





import { useTranslate  } from '../common/language';
import { logoProject  } from '../common/constants';



import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


export const ValidateSender = props => {
    
  const translate = useTranslate();  
  const dataProvider = useDataProvider();
    
  const [info, setInfo] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [errorApi, setErrorApi] = useState();
  const [create] = useCreate('senders/validate');
  const refresh = useRefresh(); 
  const notify = useNotify();
  const [formSent, setFormSent] = useState();
    
  const { token: token_string } = parse(props.location.search);
  const token = token_string ? token_string : '';
    
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
        
    create(            
      { payload: { data: { token : token } } },
      {
        onSuccess: ({ data }) => {              
          setFormSent(true);
          setErrorApi('');
        },
        onFailure: ( error ) => {
          setErrorApi(error.message);                     
        }
      }
    );
       
  }, []);
  

    if (errorApi) return translate('senders.validate_ko');
    if (!formSent) return null;  

    return (
      <Box sx={{ width: '50%', maxWidth: 800, bgcolor: 'background.paper', padding: '20px' }} className="add_member_box" >
        <Grid container spacing={1} >
          <Grid item xs={12} sm={12}>
            <center><img src={logoProject} /></center>
          </Grid>
        </Grid> 

        <div className="add_member_form_sent" dangerouslySetInnerHTML={{ __html: errorApi ? translate('senders.validate_ko') : translate('senders.validate_ok') }} />

      </Box>
    );
  
};
